import { createFileRoute } from '@tanstack/react-router'
import PageEntrance from '~components/motion/page-entrance'
import MainConcern from '~containers/app/ask-a-vet/3_main-concern'

export const Route = createFileRoute('/samsung/smart-things/(app)/ask-a-vet/main-concern')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <PageEntrance>
      <MainConcern />
    </PageEntrance>
  )
}
